export default __webpack_public_path__ + "static/media/autosetLimit-ai.fb8f53ee.png";